// @flow
import FileView from './FileView';
import CrossButton from './CrossButton';

export default FileView;
export { CrossButton };
